import { Mongo } from 'meteor/mongo';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';

export const Places = new Mongo.Collection('flight_places');
export const Place = new SimpleSchema({
    id: {
        type: SimpleSchema.RegEx.Id,
        label: "Id",
        min: 0
    },
    title: {
        type: String,
        label: "Nom du lieu d'envol"
    }
  });

Places.attachSchema(Place);



/** WEBPACK FOOTER **
 ** ./src/universal/collections/flights-type/places.js
 **/